export default [
  {
    id: 'waitlist-1',
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@test.com',
    message: 'Please add me!',
    createdAt: '2026-07-27T00:00:00.000Z',
  },
];
